import { render, staticRenderFns } from "./UserSafe.vue?vue&type=template&id=c9cd62d0&scoped=true"
import script from "./UserSafe.vue?vue&type=script&lang=ts"
export * from "./UserSafe.vue?vue&type=script&lang=ts"
import style0 from "./UserSafe.vue?vue&type=style&index=0&id=c9cd62d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cd62d0",
  null
  
)

export default component.exports